<template>
  <div>
    <quiz-options
      :options="options"
      v-bind="$props"
      :is-multiselect="isMultiselect"
      v-on="$listeners"
    />
    <div class="mx-auto mt-3 other-input-wrapper">
      <eg-b-form-input
        v-if="isOtherSelected"
        :value="otherValue"
        type="text"
        :placeholder="placeholder"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
import QuizOptions from "@/components/dashboard/quiz/quiz_options.vue";
import { USER_ROLE } from "@/constants";

export default {
  name: "FirstQuizStep",

  components: {
    QuizOptions,
  },

  props: {
    value: {
      type: [String, Array, Object],
      default: null,
      required: true,
    },
    otherValue: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    isMultiselect: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Enter your other variant",
    },
  },

  computed: {
    isOtherSelected() {
      const v = this.value;
      const isOtherObject = (candidate) =>
        candidate &&
        typeof candidate === "object" &&
        (candidate.translationKey === USER_ROLE.other.translationKey ||
          candidate.value === "other");
      if (v == null) {
        return false;
      }
      if (Array.isArray(v)) {
        return v.some((item) => item === "other" || isOtherObject(item));
      }
      if (typeof v === "object") {
        return isOtherObject(v);
      }
      return v === "other";
    },
  },

  methods: {
    handleInput(value) {
      this.$emit("input:other", value);
    },
  },
};
</script>

<style scoped lang="scss">
.other-input-wrapper {
  width: 696px; // match quiz wrapper width
}
</style>
